import React from "react";
import BarChartWob from "../../Components/Charts/ActualVsExpectedMixChart/BarChartWob";
import TwoColumnChart from "../../Components/Charts/TwoColumnChart/TwoColumnChart";
import SalesColumnChart from "../../Components/Charts/SalesColumnChart/SalesColumnChart";
import BrandSales from "../../Components/Charts/ActualVsExpectedMixChart/BrandSales";
import MarketComparisonTable from "src/Components/Tables/MarketComparison/MarketComparison";
import BarChartWobContribution from "src/Components/Charts/BarChartWobContribution/BarChartWobContribution";
import { Box } from "@mui/material";
import TwoColumnVolumeChart from "../../Components/Charts/TwoColumnVolumeChart/TwoColumnVolumeChart";
import MarketKPIsTable from "src/Components/Tables/MarketKPIsTable/MarketKPIsTable.jsx";
import NewTable from "src/Components/Tables/MarketGrowthTable/MarketGrowthTable";
import MarketGrowthContribution from "src/Components/Charts/MarketGrowthContribution/MarketGrowthContribution";
import SegmentsRetailerValueSalesChart from "src/Components/Charts/SegmentsRetailerValueSalesChart/SegmentsRetailerValueSalesChart";
import MarketContributionSegments from "src/Components/Charts/MarketContributionSegments/MarketContributionSegments";
// Responsive adjustments
export const data = [
  {
    id: "BrandSales",
    component: (
      <Box sx={{ width: "100%", overflow: "hidden" }}>
        <BrandSales />
      </Box>
    ),
    componentName: "BrandSales",
    name: "Brand Sales",
    title: "Market Trends",
    xs: 12,
    sm: 12,
    md: 12,
  },
  {
    id: "MarketKPIsTable",
    component: (
      <Box sx={{ width: "100%", overflow: "hidden" }}>
        <MarketKPIsTable />
      </Box>
    ),
    componentName: "MarketKPIsTable",
    name: "Market KPIs Table",
    title: "Market vs Manufacturer Performance",
    xs: 12,
    sm: 12,
    md: 12,
  },
  // {
  //   id: "TwoColumnChart1",
  //   component: (
  //     // <TwoColumnChartPriceIndex
  //     // title={"Value Sales Growth vs. YO"}
  //     // />
  //     <Box sx={{ overflowX: "auto", width: "100%" }}>
  //       <MarketComparisonTable />
  //     </Box>
  //   ),
  //   componentName: "MarketComparisonTable",
  //   name: "Price Index",
  //   title: "Market Comparison",
  //   xs: 12, // Full width on mobile
  //   sm: 12, // Full width on small screens
  //   md: 6, // Half width on medium screens
  // },
  {
    id: "WobData",
    component: (
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <BarChartWob />
      </Box>
    ),
    componentName: "BarChartWob",
    name: "WobData",
    title: "Weight of Business",
    xs: 12,
    sm: 6,
    md: 6,
  },
  {
    id: "ContributionData",
    component: (
      <Box sx={{ overflowX: "auto" }}>
        <BarChartWobContribution />
      </Box>
    ),
    componentName: "BarChartWobContribution",
    name: "ContributionData",
    title: "Contribution to Growth-Decline",
    xs: 12,
    sm: 6,
    md: 6,
  },
  {
    id: "NewTable",
    component: <NewTable />,
    componentName: "NewTable",
    name: "Market Growth Contributors",
    title: "Market Growth",
    xs: 12,
    sm: 12,
    md: 12,
  },
  {
    id: "MarketGrowthContribution",
    component: (
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <MarketGrowthContribution />
      </Box>
    ),
    componentName: "MarketGrowthContribution",
    name: "Market Growth Contribution",
    title: "Market Growth Contribution (Waterfall)",
    xs: 12,
    sm: 12,
    md: 12,
  },
  {
    id: "SegmentsRetailerValueSalesChart",
    component: (
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <SegmentsRetailerValueSalesChart />
      </Box>
    ),
    componentName: "SegmentsRetailerValueSalesChart",
    name: "Segments/Retailer Value Sales & Avg Price Per Kg",
    title: "Segments/Retailer Value Sales & Avg Price Per Kg",
    xs: 12,
    sm: 12,
    md: 12,
  },
  {
    id: "MarketContributionSegments",
    component: (
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <MarketContributionSegments />
      </Box>
    ),
    componentName: "MarketContributionSegments",
    name: "Market Contribution by Segments",
    title: "Market Contribution by Segments/Retailer",
    xs: 12,
    sm: 12,
    md: 12,
  },
  {
    id: "volumeSalesChart",
    component: <TwoColumnChart />,
    componentName: "TwoColumnChart",
    name: "Value Sales YA",
    title: "Value Sales Growth vs. YO",
    xs: 12, // Full width on mobile
    sm: 12,
    md: 3,
  },
  {
    id: "volumeVolumeChart",
    component: <TwoColumnVolumeChart />,
    componentName: "TwoColumnVolumeChart",
    name: "Volumes Sales YA",
    title: "Volume Sales Growth vs. YO",
    xs: 12, // Full width on mobile
    sm: 12,
    md: 3,
  },
];
